/* The three "Opłaty urzędowe" nav badges. One vocabulary for the sidebar dot
   (hover title), the legend buttons on the list page and the feed's `?badge=`
   filter (backend apps/official_fees/badges.py), so a click on a legend button
   shows exactly the rows the sidebar counted. */

export type OfficialFeeBadge =
  | "pending_approval"
  | "pending_payment"
  | "pending_acknowledgement";

export const OFFICIAL_FEE_BADGE_LABELS: Record<OfficialFeeBadge, string> = {
  pending_approval: "oczekuje na Twoją akceptację",
  pending_payment: "zaakceptowane — do opłacenia",
  pending_acknowledgement: "potwierdzenie płatności przesłane — potwierdź odbiór",
};

/* Sidebar tooltip = the legend label with a capital, so both places read the same. */
export const OFFICIAL_FEE_BADGE_TITLES: Record<OfficialFeeBadge, string> = {
  pending_approval: "Oczekuje na Twoją akceptację",
  pending_payment: "Zaakceptowane — do opłacenia",
  pending_acknowledgement: "Potwierdzenie płatności przesłane — potwierdź odbiór",
};

export const OFFICIAL_FEE_BADGE_COLORS: Record<OfficialFeeBadge, "red" | "amber"> = {
  pending_approval: "red",
  pending_payment: "red",
  pending_acknowledgement: "amber",
};
